import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { uiActions } from "../../store";
import PopUpModal from "../PopUpModal/PopUpModal";
import styles from "./VisualizerHelp.module.css";


// Define slides array - easy to add/remove slides
// Add image URLs to each slide (can be local imports or external URLs)
const slides = [
    {
        id: 'welcome',
        title: 'Help',
        image: null, // No image for welcome slide, or add one if needed
        content: 'Learn how to create beautiful flooring patterns with our easy-to-use visualizer. Click Start to begin the tutorial.',
        isWelcome: true
    },
    {
        id: 'start-design',
        title: 'Start Your Design',
        image: '/help/start-design.jpg', // Replace with actual image path
        content: 'Begin by selecting a pattern. This creates the base layout for your design.'
    },
    {
        id: 'pick-color-scheme',
        title: 'Select pattern colors',
        image: '/help/start-colors.jpg', // Replace with actual image path
        content: 'Select the number of colors in your pattern'
    },
    {
        id: 'apply-products',
        title: 'Apply Products to Surfaces',
        image: '/help/apply-color.jpg', // Replace with actual image path
        content: 'Click a surface block (A, B, C, etc.) to activate it, then choose a product from the Abstract, Stone, or Wood categories to apply.'
    },
    {
        id: 'find-products',
        title: 'Find Products Faster',
        image: '/help/search.jpg', // Replace with actual image path
        content: 'Use the search box to filter products by collection name, style, or color. Results update as you type.'
    },
    {
        id: 'new-pattern',
        title: 'Start Over',
        image: '/help/new-pattern.jpg', // Replace with actual image path
        content: (
        <>
            Use the New Pattern button to start over. Select <strong>Save</strong> in the hamburger menu to not lose your work on your existing project.
        </>
        )
    },
    {
        id: 'preview-room',
        title: 'Preview in a Room',
        image: '/help/view-room.jpg', // Replace with actual image path
        content: 'When your pattern is complete, click View in a Room. Select a room to see how your design looks in a real-world setting. You can switch between rooms at any time.'
    },
    {
        id: 'make-changes',
        title: 'Make Changes',
        image: '/help/edit.jpg', // Replace with actual image path
        content: 'Select Edit Pattern to swap products, adjust surface selections, or refine your design at any stage.'
    },
    {
        id: 'save-projects',
        title: 'Save and My Projects',
        image: '/help/save.jpg', // Replace with actual image path
        content: 'Open the hamburger menu to save your current project. Return to My Projects anytime to continue working on past designs.'
    },
    {
        id: 'download-print',
        title: 'Download or Print',
        image: '/help/pdf.jpg', // Replace with actual image path
        content: 'From the hamburger menu, choose Download Pattern Image to save a digital image, or select Print Design to generate a printable or shareable summary of your pattern and selected products.'
    },
    {
        id: 'additional-tools',
        title: 'Additional Tools',
        image: '/help/mixed.jpg', // Replace with actual image path
        content: 'Share or email your design, clear the pattern, or use undo and redo to quickly reverse changes.'
    }
];

export default function VisualizerHelp() {
    const dispatch = useDispatch();
    const [currentSlide, setCurrentSlide] = useState(0);

    const handleClose = function () {
        dispatch(uiActions.setVisualizerHelpModalActive(false));
        setCurrentSlide(0); // Reset to first slide when closing
    }

    const handleStart = () => {
        setCurrentSlide(1);
    };

    const handleNext = () => {
        if (currentSlide < slides.length - 1) {
            setCurrentSlide(currentSlide + 1);
        }
    };

    const handlePrev = () => {
        if (currentSlide > 0) {
            setCurrentSlide(currentSlide - 1);
        }
    };

    const handleFinish = () => {
        handleClose();
    };

    const slide = slides[currentSlide];
    const isFirstSlide = currentSlide === 0;
    const isLastSlide = currentSlide === slides.length - 1;

    return (
        <>
            <PopUpModal handleClose={handleClose}>
                <div className={styles.mainContent}>
                    {/* <h2>Visualizer Help</h2> */}

                    <div className={styles.slideContainer}>
                        <div className={styles.slideContent}>
                            <h3 className={styles.slideTitle}>{slide.title}</h3>
                            
                            {slide.image && (
                                <div className={styles.slideImageContainer}>
                                    <img 
                                        src={slide.image} 
                                        alt={slide.title}
                                        className={styles.slideImage}
                                    />
                                </div>
                            )}
                            
                            <p className={styles.slideText}>{slide.content}</p>
                        </div>

                        <div className={styles.slideNavigation}>
                            {isFirstSlide ? (
                                <button 
                                    className={styles.startButton}
                                    onClick={handleStart}
                                >
                                    Start
                                </button>
                            ) : (
                                <>
                                    <button 
                                        className={styles.navButton}
                                        onClick={handlePrev}
                                    >
                                        Previous
                                    </button>
                                    
                                    {isLastSlide ? (
                                        <button 
                                            className={styles.finishButton}
                                            onClick={handleFinish}
                                        >
                                            Finish
                                        </button>
                                    ) : (
                                        <button 
                                            className={styles.navButton}
                                            onClick={handleNext}
                                        >
                                            Next
                                        </button>
                                    )}
                                </>
                            )}
                        </div>

                        <div className={styles.slideIndicator}>
                            {currentSlide + 1} / {slides.length}
                        </div>
                    </div>

                </div>
            </PopUpModal>
        </>
    );
}